import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FiltrosProducaoRetornoService {
  private dateInicio = new BehaviorSubject<string | "">("");
  private dateFim = new BehaviorSubject<string | "">("");
  private instanciaSelecionada = new BehaviorSubject<string | "">("");

  rangeDates!: string;

  currentDataInicio = this.dateInicio.asObservable();
  currentDataFim = this.dateFim.asObservable();
  currentInstancia = this.instanciaSelecionada.asObservable();


  alteraDataInicio(date: string | ""){
    this.dateInicio.next(date);
  }

  alteraDataFim(date: string | ""){
    this.dateFim.next(date);
  }

  alteraInstancia(instancia: string)
  {
    this.instanciaSelecionada.next(instancia);

  }
}
